import { useParams, useNavigate } from "react-router";
import { Button } from "@illustraclass/ui";
import { ArrowLeft } from "lucide-react";

export function ExperimentPage() {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();

  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background text-foreground"
      role="status"
    >
      <h1 className="text-2xl font-bold">Expérience non trouvée</h1>
      <p className="text-muted-foreground">
        L'expérience « {slug} » n'est pas encore disponible.
      </p>
      <Button
        variant="outline"
        onClick={() => {
          void navigate("/dashboard");
        }}
      >
        <ArrowLeft className="mr-2 h-4 w-4" />
        Retour au tableau de bord
      </Button>
    </div>
  );
}

export function ExperimentLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="text-center">
        <div className="mx-auto mb-4 h-12 w-12 animate-spin rounded-full border-4 border-primary border-t-transparent" />
        <p className="text-lg text-muted-foreground">
          Chargement de l'expérience…
        </p>
      </div>
    </div>
  );
}
